$( function () {
	var nav = $( 'header' );
	$(window).on('load scroll', function() {
		if ( $(window).scrollTop() > 90 ) {
			nav.addClass( 'h_fixed' );
		} else {
			nav.removeClass( 'h_fixed' );
		}
        if ( $(window).scrollTop() >  140 ) {
			nav.addClass( 'h_scroll' );
		} else {
			nav.removeClass( 'h_scroll' );
		}
	} );
} );

$(window).on('load resize', function(){
    var h_h = $('header.header.header--middle-left').outerHeight();
    $('.h_pt').css('padding-top', h_h);
});


$(window).on('load resize scroll', function() {
    var utilityBarHeight = $('.utility-bar').outerHeight() || 0;
    var scrollTop = $(window).scrollTop();

    if (scrollTop < utilityBarHeight) {
        // ユーティリティバー範囲内では、header と MainContent をずらす
        $('header.header').css('top', utilityBarHeight - scrollTop);
        $('#MainContent').css('margin-top', utilityBarHeight - scrollTop);
    } else {
        // ユーティリティバーの高さ以上スクロールしたらリセット
        $('header.header').css('top', 0);
        $('#MainContent').css('margin-top', 0);
    }
});




$(window).on('load', function(){
	$('html').animate({opacity: 1}, 300, 'linear');
});
	
$('.hmbg_btn').click(function(){
    $('.hmbg_wrap').toggleClass('open');
    $('html').toggleClass('hmbg_open');
});
$('.sp_nav_li > li').each(function(i){
    var anm = .1*i;
    $(this).css('transition-delay', anm+'s');
});

	
$(function(){
	$("#back-top").hide(), $(function(){
		$(window).scroll(function(){
			$(this).scrollTop() > 0 ? $(".pagetop").fadeIn() : $(".pagetop").fadeOut()
		}), $("#back-top a").click(function(){
			return $("body,html").animate({
				scrollTop: 0
			}, 800, "easeOutExpo"), !1
		})
	})
})

if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
	$(function(){
		$('.tel').each(function(){
			var str = $(this).html();
			$(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
		});
	});
}
	
$(window).on('load', function() {
	const url = $(location).attr('href'),
	headerHeight = $('#header').outerHeight();
	if(url.indexOf("#") != -1){
		const anchor = url.split("#"),
		target = $('#' + anchor[anchor.length - 1]),
		position = Math.floor(target.offset().top) - headerHeight;
		$("html, body").scrollTop(position);
	}
});//別ページに移動する場合のアンカーリンク
	
jQuery(function(){
    var windowWidth = $(window).width();
    var headerHight = $('#header').outerHeight();
    jQuery('a[href^=#]:not(.modal)').click(function() {
    var href= jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHight;
    jQuery('body,html').animate({scrollTop:position});
    return false;
   });
});//ページ内移動の場合のアンカーリンク
    
var accordion = $(".acc-wrap");
accordion.each(function(){
	var noTargetAccordion = $(this).siblings(accordion);
	$(this).find(".acc-btn").click(function(){
		$(this).next(".acc-cont").slideToggle();
		$(this).toggleClass("acc-open");
		noTargetAccordion.find(".acc-cont").slideUp();
		noTargetAccordion.find(".acc-btn").removeClass("acc-open");
	});
});
/*
<div class="acc-wrap">
	<div class="acc-btn"></div>
	<div class="acc-cont"></div>
</div>
*/
	
$(function(){
	$('.modal_cont').each(function(){
		var block_id = $(this).attr('id');
		$('body').append('<div class="modal_cont_wrapper" modal-data="'+block_id+'"><div class="modal_cont_inner"></div></div>');
		$(this).appendTo('.modal_cont_wrapper[modal-data="'+block_id+'"] .modal_cont_inner');
		$(this).children('.modal_block').append('<div class="modal_close"><div class="modal_close_inner"></div></div>');
	});
	$('.modal').click(function(){
		var id = $(this).attr('href');
		$(id).parent('.modal_cont_inner').fadeToggle(400);
		$(id).parents('.modal_cont_wrapper').fadeToggle(400);
		$('body > .wrapper').toggleClass('modal_open');
		$('.modal_close').click(function(){
			$(id).parent('.modal_cont_inner').fadeOut(400);
			$(id).parents('.modal_cont_wrapper').fadeOut(400);
			$('body').removeClass('modal_open');
		});
	});
});
/*
<a href="#modal_sample" class="modal"></a>
<div id="modal_sample" class="modal_cont">
	<div class="modal_block"></div>
</div>
*/
	
$(window).on('load scroll resize', function(){
	$('.scrl').each(function(){
		var scrolltop = $(window).scrollTop();
		var w_h = $(window).outerHeight() / 1.5;
		var ofst = $(this).offset().top;
		var ofst_h = ofst - w_h;
		if(ofst_h < scrolltop){
			$(this).addClass('scrl_in');
		}
	});
});
/*
<div class="scrl bt-anim">
</div>
*/

$(function(){
	$('.header__inline-menu .list-menu.list-menu--inline > li').eq(0).after('<li><span class="mega_m_btn header__menu-item list-menu__item link link--text focus-inset">PRODUCTS</span></li>');;
});
$(function() {
  let hideTimer;
  $(document)
    .on('mouseenter', '.mega_m_btn', function() {
      clearTimeout(hideTimer);
      $('.mega_gnav').addClass('active');
    })
    .on('mouseleave', '.mega_m_btn', function() {
      hideTimer = setTimeout(function() {
        $('.mega_gnav').removeClass('active');
      }, 150);
    })
    .on('mouseenter', '.mega_gnav', function() {
      clearTimeout(hideTimer);
    })
    .on('mouseleave', '.mega_gnav', function() {
      hideTimer = setTimeout(function() {
        $('.mega_gnav').removeClass('active');
      }, 150);
    });
});
//--common--